import React, { useEffect, useState, useRef } from "react";
import Dompurify from 'dompurify'
import { Skeleton, Card, Row, Col, Avatar, Result, message } from "antd";
import { useParams } from 'react-router-dom'
import { DynamicForm, PayButton, SmartPayUtil, EasebuzzFooter, ASSETS_URL, DEFAULT_CUSTOMIZATION_CONFIG } from "../../utility";
import draftToHtml from 'draftjs-to-html';
import { SmartPayApi } from "../../services/api";
import SmartPayError from "../error";
import arrow_up_line from "../../assets/icons/arrow_up_line.png"
import 'antd/dist/antd.css';
import '../../styles/index.css';
const isMobile = window.innerWidth <= 810

const SmartPay = () => {
    let initialState = {
        isLoading: true,
        data: {},
        submerchant_list: [],
        txn: {},
        error: {
            status: 'error',
            showError: false,
            errorTitle: '',
            errorMsg: '',
            showDesc: false,
        },
        feedback: {
            status: false,
            isPostPaymentFormLoading: false,
        },
        isPaymentCardLoading: false,
        formData: {},
    }
    const { url, mid, txn_id } = useParams();
    const [state, setState] = useState(initialState);
    const paymentPageRef = useRef(null);
    const postPaymentPageRef = useRef(null);
    const [sliderClass, setSliderClass] = useState("down")
    const [desc, setDesc] = useState(true);
    const [prevData, setPrevData] = useState(null);
    const [isUserFormOpen, setUserFormOpen] = useState(false);

    useEffect(() => {
        getSmartLinkInfo();
    }, [])

    const actionwhenMobileViewOn = () => {
        if (desc) {
            setSliderClass("slideup")
            setDesc(false)
        }
        else handlePayClick();
    }

    const getSmartLinkInfo = async () => {
        let payment_url = ([mid, url]).join("/");
        if (txn_id !== undefined && txn_id !== null) {
            payment_url = ([mid, url, txn_id]).join("/");
        }
        let urlParams = new URLSearchParams(window.location.search);
        let queryData = Object.fromEntries(urlParams.entries());
        delete queryData['amount'];
        await SmartPayApi.get_smart_pay_link(payment_url, {}).then((response) => {
            if (response.status) {
                setState((prevState) => ({
                    ...prevState,
                    txn: response.txn,
                    formData: queryData,
                    submerchant_list: response.submerchant_list,
                    data: new SmartPayUtil(response.data),
                    isLoading: false,
                }))
            }
        }).catch((e) => {
            if (e.response !== undefined) {
                setState((prevState) => ({
                    ...prevState,
                    isLoading: false,
                    error: {
                        status: e.response.data.error.code,
                        showError: true,
                        errorTitle: e.response.data.error.message,
                        errorMsg: e.response.data.error.submessage,
                    }
                }))
            } else {
                setState((prevState) => ({
                    ...prevState,
                    isLoading: false,
                    error: {
                        status: "500",
                        showError: true,
                        errorTitle: "Oops.! Something went wrong",
                        errorMsg: e.response.data.error.submessage
                    }
                }))
            }
        })
    }

    const proceedToPayment = (values) => {
        setSliderClass('after-paynow')
        //TODO: Use transformer for field name as well in future.
        const transformer = (field) => {
            switch (field.type) {
                case "FixedNumberInput": return field.default_value;
                case "MultiRegionPhoneNumberInputField": return field.prefix + "-" + field.value;
                case "SubmerchantDropDown": return field.value !== "" ? field.value.split("-")[0].trim() : null;
                default: return field.value;
            }
        }
        let queryData = {
            data: values.map((field, index) => {
                return {
                    alias: field.alias,
                    name: field.name,
                    value: transformer(field),
                }
            })
        }
        setState((prevState) => ({
            ...prevState,
            isPaymentCardLoading: true,
        }))
        SmartPayApi.proceed_to_save_payment_details(mid + "/" + url, queryData).then((response) => {
            if (response.status && response.link.status)
                window.location.href = response.link.data.payment_url;
            else {
                setState((prevState) => ({
                    ...prevState,
                    isPaymentCardLoading: false,
                }));
                if (response.link.error && response.link.error.hasOwnProperty('non_field_errors') !== undefined) {
                    response.link.error.non_field_errors.map(error => {
                        message.error(`Unable to create link - ${Object.values(error)}`)
                        return null
                    })
                }
                else if (response.link.hasOwnProperty('message')){
                    message.error(response.link.message);
                }
                else if (typeof (response.link.error) === "string") {
                    message.error(response.link.error);
                }
                else {
                    message.error(Object.values(response.link.error).toString())
                }
                // throw new Error('unable to get payment link');
            }
        }).catch((e) => {
            setState((prevState) => ({
                ...prevState,
                isPaymentCardLoading: false,
            }));
            message.error("Unable to save details at the moment");
        })
    }

    const updateFeeback = (values) => {
        let queryData = {
            ...values.map((field, index) => {
                if (field.end_user_mandatory) {
                    return {
                        alias: field.alias,
                        name: field.name,
                        value: field.type === "FixedNumberInput" ? field.default_value : field.value,
                    }
                }
                return null;
            }),
        }
        SmartPayApi.update_smart_pay_link(mid + "/" + url + "/" + txn_id, queryData).then((response) => {
            if (response.status) {
                setState((prevState) => ({
                    ...prevState,
                    feedback: {
                        status: response.status,
                        isPostPaymentFormLoading: false,
                    }
                }))
                message.success('feedback submitted successfully.')
            } else {
                message.error('unable to submit feedback.')
                throw new Error();
            }
            // setPrevData(null)
        }).catch((e) => {
            setState((prevState) => ({
                ...prevState,
                feedback: {
                    status: false,
                    isPostPaymentFormLoading: false,
                }
            }))
            // setPrevData(null)
        })
    }

    const changeDescView = () => {
        if (paymentPageRef.current)
            setPrevData(paymentPageRef.current.getFieldsValue().dynamic_form)
        if (desc)
            setSliderClass("slideup")
        else
            setSliderClass("slidedown")
        setDesc(prevState => !prevState);
    };

    const handlePayClick = () => {
        paymentPageRef.current.validateFields().then((values) => {
            proceedToPayment(values.dynamic_form);
        }).catch((e) => {
            message.error("Please fill the values");
        })
    }

    const PaymentInfoForm = () => {
        let customization = state.data.settings.display_config.pre_payment_page.customization || DEFAULT_CUSTOMIZATION_CONFIG;
        let dynamicFormProps = {
            ref: null,
            fields: state.data.settings.display_config.pre_payment_page.page_footer.content.fields,
            cssConfig: {
                formItemStyle: {
                    margin: 2,
                    fontWeight: 900,
                },
            },
            labelCol: {
                xs: { span: 10 },
                sm: { span: 10 },
                lg: { span: 10 },
                xl: { span: 7 },
            },

            wrapperCol: {
                xs: { span: 14 },
                sm: { span: 14 },
                lg: { span: 14 },
                xl: { span: 17 },
            },
            formCss: { width: "100%" }
        }
        let footerProps = {
            footerImage: {
                styleClass: 'smart-payment-footer-image',
            },
            showTerms: true,
            merchantDetails: {
                merchant_name: state.data.merchant_name,
            }
        }
        return (
            <div className="smart-pay-info-form">
                <RenderLogoAndName isRender={true} customization={customization} isPrePayment={true} />
                {isMobile ? null : <br />}
                <Row>
                    <div className="smart-payment-description">
                        <div className="smart-payment-block"><span className="smart-payment-title">{state.data.page_title.value}</span></div>
                        <div><div className={isMobile && !desc ? "smart-payment-inline-description-not-expanded" : "smart-payment-inline-description"}
                            dangerouslySetInnerHTML={{ __html: Dompurify.sanitize(draftToHtml(state.data.page_description.value)) }}></div></div>
                        {isMobile ?
                            <div>
                                {desc ? null : <span className="link-view" onClick={changeDescView}>View Description</span>}
                            </div>
                            : null
                        }
                        <div className="smart-payment-block"><div className="smart-payment-footer">
                            <DynamicForm {...dynamicFormProps} /></div>
                        </div>
                        <EasebuzzFooter {...footerProps} />
                    </div>
                </Row>
            </div>
        )
    }

    const changeSlideClass = () => sliderClass === "slideup" ? setSliderClass('slidedown') : setSliderClass('slideup');

    const setQueryParams = (fields) => {
        if (state.formData) {
            for (var i=0; i<fields.length; i++) {
                let value = state.formData[fields[i]['alias'].toLowerCase().split(" ").join("_")];
                if (["SubmerchantDropDown", "DatePicker", "RatePicker"].includes(fields[i]['type']))
                    fields[i]['value'] = "";
                else if (["UserNumberInput", "NumberField"].includes(fields[i]['type'])) {
                    if (new RegExp("^[0-9]*$").test(value))
                        fields[i]['value'] = value;
                }
                else if (['DropDown', 'RadioBox', 'CheckBox'].includes(fields[i]['type'])) {
                    if (fields[i]['options'].includes(value))
                        fields[i]['value'] = value;
                }
                else
                    fields[i]['value'] = value;
            }
        }
    }

    const PaymentForm = () => {
        let labelCol = {
            xs: { span: 10 },
            sm: { span: 10 },
            lg: { span: 10 },
            xl: { span: 10 },
        }
        let wrapperCol = {
            xs: { span: 14 },
            sm: { span: 14 },
            lg: { span: 14 },
            xl: { span: 14 },
        }
        let fields = state.data.settings.display_config.pre_payment_page.page_body.content.fields;
        setQueryParams([...fields]);
        return (
            <div>
                {isMobile ?
                    <>
                        <Card
                            className={`fixed-footer-form pre-payment-card ${sliderClass}`}
                            bodyStyle={desc ? {} : { overflowY: "scroll", height: "100%", paddingBottom: "35%", borderBottom: "none" }}
                            title={
                                <>
                                    {desc ? null : <span className={`preform-title-mobile`}>Payment Details</span>}
                                    <img src={arrow_up_line} className={desc ? 'rotate_icon pay-btn-icon' : 'pay-btn-icon'}
                                        onClick={(e) => { e.stopPropagation(); changeDescView() }} alt="arrow" width={28} height={13} />
                                </>
                            }
                            extra={!desc ?
                                <div className="payment-card-info">
                                    <span><img className="payment-images" src={ASSETS_URL['google_pay_local']} alt=""></img></span>
                                    <span><img className="payment-images" src={ASSETS_URL['visa_local']} alt=""></img></span>
                                    <span><img className="payment-images" src={ASSETS_URL['master_card_local']} alt=""></img></span>
                                    <span><img className="payment-images" src={ASSETS_URL['upi_local']} alt=""></img></span>
                                </div>
                                : null
                            }
                        >
                            <Skeleton loading={state.isPaymentCardLoading} title="Loading.." active paragraph={{ rows: fields.length }}>
                                <Row>
                                    <DynamicForm
                                        ref={paymentPageRef}
                                        fields={prevData ? prevData : fields}
                                        labelCol={labelCol}
                                        wrapperCol={wrapperCol}
                                        active_submerchants={state.submerchant_list}
                                        formCss={{ width: "100%" }}
                                    />
                                </Row>
                            </Skeleton>
                        </Card>
                        <Card
                            className={"smart-paybtn fixed-footer-form"}
                            bodyStyle={{ padding: "0px", border: "none" }}
                            actions={[
                                <PayButton
                                    className="fixed-footer-form"
                                    text={"Pay Now"}
                                    showPaymentImages={true}
                                    handleOnClick={() => actionwhenMobileViewOn()}
                                    isPreMobile={isMobile}
                                />
                            ]}>
                        </Card>
                    </>
                    :
                    <Card className="smart-payment-card" title="Payment Details" extra={
                        <div className="payment-card-info">
                            <span><img className="payment-images" src={ASSETS_URL['google_pay_local']} alt=""></img></span>
                            <span><img className="payment-images" src={ASSETS_URL['visa_local']} alt=""></img></span>
                            <span><img className="payment-images" src={ASSETS_URL['master_card_local']} alt=""></img></span>
                            <span><img className="payment-images" src={ASSETS_URL['upi_local']} alt=""></img></span>
                        </div>
                    } bordered={false} actions={[
                        <PayButton text={"Pay Now"}
                            showPaymentImages={true} handleOnClick={handlePayClick} />
                    ]}>
                        <Skeleton loading={state.isPaymentCardLoading} active paragraph={{ rows: fields.length }}>
                            <Row>
                                <DynamicForm
                                    ref={paymentPageRef}
                                    fields={fields}
                                    labelCol={labelCol}
                                    wrapperCol={wrapperCol}
                                    active_submerchants={state.submerchant_list}
                                    formCss={{ width: "100%" }}
                                />
                            </Row>
                        </Skeleton>
                    </Card>
                }
            </div>
        );
    }

    const PrePaymentPage = () => {
        if (!txn_id) {
            return (
                <Row className="smart-pay-pre" gutter={24}>
                    <Col className="col-description" xl={{ span: 14 }} lg={{ span: 14 }} xs={{ span: 24 }}>
                        <PaymentInfoForm />
                    </Col>
                    <Col className="col-payment" xl={{ span: 10 }} lg={{ span: 10 }} xs={{ span: 24 }}>
                        <PaymentForm />
                    </Col>
                </Row>
            )
        }
        return <SmartPayError status={404} title={state.error.errorTitle} errorMsg={state.error.errorMsg} />
    }

    const RenderPostPaymentDescription = (DescProps) => {
        const { dynamicFormProps, footerProps } = DescProps
        if (isMobile) {
            return (
                <Card
                    title={'Payment Description'}
                    bordered={true}
                    className={`payment-desc-info ${['success'].includes(state.txn.data.status) && state.txn.is_postpayment_feedback_completed ? `desc-body-heigth` : ``}`}  >
                    <div className={`smart-payment-block post-payment-desc`}>
                        <DynamicForm  {...dynamicFormProps} />
                    </div>
                    <EasebuzzFooter {...footerProps} />
                </Card>
            )
        }
        return (
            <Row>
                <div className={`post-smart-payment-description`}>
                    <div className="smart-payment-block">
                        <DynamicForm {...dynamicFormProps} />
                    </div>
                    <EasebuzzFooter {...footerProps} />
                </div>
            </Row>
        )
    }

    const PostPaymentInfoForm = () => {
        let customization = state.data.settings.display_config.post_payment_page.customization || DEFAULT_CUSTOMIZATION_CONFIG;
        let dynamicFormProps = {
            ref: null,
            fields: state.data.settings.display_config.post_payment_page.page_header.content.fields || [],
            labelData: state.txn.data,
            labelCol: {
                xs: { span: 12 },
                sm: { span: 10 },
                lg: { span: 10 },
                xl: { span: 7 },
            },
            wrapperCol: {
                xs: { span: 12 },
                sm: { span: 14 },
                lg: { span: 14 },
                xl: { span: 17 },
            },
            formCss:{  width:"100%" }
        }
        let footerProps = {
            footerImage: {
                styleClass: 'smart-payment-footer-image',
            },
            showTerms: true,
            merchantDetails: {
                merchant_name: state.data.merchant_name,
            }
        }
        return (
            <div className={isMobile ? "" : "smart-pay-info-form"}>
                <RenderLogoAndName isRender={!isMobile} customization={customization} isPrePayment={false} />
                <br />
                <RenderPostPaymentDescription dynamicFormProps={dynamicFormProps} footerProps={footerProps} />
            </div>
        )
    }

    const RenderLogoAndName = ({ isRender, customization, isPrePayment = true }) => {

        let main_class = isPrePayment ? `pre-payment-logo-title-main` : isMobile ? `mobile-view-avator-title` : `display-inline`
        let avatar_class = isPrePayment ? isMobile && !desc ? `logo2` : `logo1` : ``
        let merchant_class = isPrePayment ? isMobile && !desc ? `pre-smart-pay-merchant-name-small text-space` : `pre-smart-pay-merchant-name text-space` : `smart-pay-merchant-name post-payment-merchant-name`

        if (isRender) {
            return (
                <div className={main_class}>
                    {customization.logo.required ? <Avatar className={avatar_class} src={state.data.merchant_logo}
                        shape="square" size={isMobile ? 50 : 100} style={customization.logo.styles}>Logo</Avatar> : null}
                    {customization.name.required ? <span className={merchant_class}
                        style={customization.name.styles}>{state.data.merchant_name}</span> : null}
                </div>
            )
        }
        return null
    }

    const getStatusDescription = (key) => {
        const status = {
            "success": <><p>Your payment has completed successfully</p></>,
            "userCancelled": <><p>It seems like you pressed the cancelled button or you terminated the payment proccess deliberately</p><p>Please try again to make the payment</p></>,
            "bounced": <><p>It seems like you left the card page and the payment process was terminated.</p><p>Please try again to make the payment</p></>,
            "dropped": <><p>It seems like you left the bank page and the payment process was terminated.</p><p>Please try again to make the payment"</p></>,
            "pending": <><p>Your payment process is still pending. Please contact us, in case if money is debited"</p></>,
            "failure": <><p>Your payment has failed.</p><p>Please try again to make the payment</p></>,
            "default": <><p>The payment has failed.</p><p>Please try again to make the payment"</p></>,
        }
        if (status.hasOwnProperty(key)) {
            return status[key]
        }
        return status['default']
    }

    const PostPaymentRetryButton = ({ isRender }) => {
        if (isRender) {
            return (
                <div className="footer-button">
                    <PayButton text={'Retry Payment'}
                        handleOnClick={(e) => {
                            e.preventDefault();
                            window.location.href = state.txn.retry.link;
                        }}
                        className="fixed-footer-form"
                        showPaymentImages={true}
                        isPreMobile={isMobile}
                        showArrow={false}
                    />
                </div>
            )
        }
        return null
    }

    const PostPaymentForm = () => {
        let resultProps = {
            title: ['success'].includes(state.txn.data.status) ? 'Payment Successful' : 'Payment Failed',
            status: ['success'].includes(state.txn.data.status) ? state.txn.data.status : 'error',
            extra: [<div className="flex-center-center"><PostPaymentRetryButton isRender={!['success'].includes(state.txn.data.status) && !isMobile} /></div>],
            subTitle: getStatusDescription(state.txn.data.status)
        }
        return (
            <Card className="post-smart-payment-card" loading={state.feedback.isPostPaymentFormLoading} bordered={false}
                actions={[<RenderPostPaymentUserFormDoneButton isRender={!isMobile && !state.txn.is_postpayment_feedback_completed}
                    button_text={'Submit Feedback'}
                    handleSubmit={() => feedbackFormSubmit()} />]}>
                <Result className="post-payment-result-icon"
                    style={{ textAlign: "center" }} {...resultProps} />
                <PostPaymentUserForm isRender={!isMobile && !state.feedback.status && !state.txn.is_postpayment_feedback_completed} />
            </Card>
        );
    }

    const feedbackFormSubmit = () => {
        postPaymentPageRef.current.validateFields().then((values) => {
            setState((prevState) => ({
                ...prevState,
                feedback: {
                    ...prevState.feedback.status,
                    isPostPaymentFormLoading: true,
                }
            }))
            updateFeeback(values.dynamic_form)
        }).catch((e) => {
            message.error("Please fill the values");
            // setPrevData(null)

        })
    }

    const handlePostPaymentUserForm = (e) => {
        e.preventDefault()
        if (sliderClass !== "slideup") {
            changeSlideClass();
            setUserFormOpen(true)
        } else {
            feedbackFormSubmit()
        }
    }

    const RenderPostPaymentUserFormDoneButton = ({ isRender = true, button_text = 'Done', handleSubmit }) => {
        // render the button if post_payment_page has fields from backend and the status of response.feedback is not true
        if (isRender && !state.feedback.status && state.data.settings.display_config.post_payment_page.page_body.content.fields.filter((f) => {
            if (!['LabelField'].includes(f.type)) {
                return f
            }
            return null;
        }).length > 0 && ['success'].includes(state.txn.data.status)) {
            return (
                <PayButton
                    text={button_text}
                    handleOnClick={handleSubmit}
                    className="fixed-footer-form"
                    showPaymentImages={true}
                    isPreMobile={isMobile}
                    showArrow={false}
                />
            )
        }
        return null
    }

    const postPaymentslidehandler = (e) => {
        if (postPaymentPageRef.current) {
            setPrevData(postPaymentPageRef.current.getFieldsValue().dynamic_form)
        }
        e.stopPropagation();
        changeSlideClass();
        setUserFormOpen(prevState => !prevState);
    }

    const PostPaymentUserForm = ({ isRender = false, title = "Feedback Form" }) => {
        let dynamicFormProps = {
            ref: postPaymentPageRef,
            fields: prevData ? prevData : state.data.settings.display_config.post_payment_page.page_body.content.fields || [],
            labelCol: {
                xs: { span: 10 },
                sm: { span: 10 },
                lg: { span: 10 },
                xl: { span: 7 },
            },
            wrapperCol: {
                xs: { span: 14 },
                sm: { span: 14 },
                lg: { span: 14 },
                xl: { span: 17 },
            },
            formCss:{ width:"100%" }
        }

        // retry form only display when transaction is successfull
        if (isRender && ['success'].includes(state.txn.data.status)) {
            if (isMobile) {
                return (<Card className={`slider-user-form ${sliderClass}`} loading={state.feedback.isPostPaymentFormLoading}
                    bodyStyle={isUserFormOpen ? { overflowY: "scroll" } : { height: "0vh" }}
                    title={
                        <>
                            {isUserFormOpen ?
                                <p className="feedbackform-title">
                                    {title}
                                </p> : null}
                            <img src={arrow_up_line} className={!isUserFormOpen ? 'rotate_icon pay-btn-icon' : 'pay-btn-icon'}
                                onClick={postPaymentslidehandler} alt="arrow" width={28} height={13} />
                        </>
                    }
                    actions={[<RenderPostPaymentUserFormDoneButton
                        button_text={'Submit Feedback'}
                        handleSubmit={(e) => handlePostPaymentUserForm(e)} />]}>
                    <DynamicForm   {...dynamicFormProps} />
                </Card>
                )
            }
            else {
                return (<div className={"post-payment-user-form"}>
                    <DynamicForm  {...dynamicFormProps} />
                </div>
                )
            }
        }
        return null
    }

    const PostPaymentPage = () => {
        let customization = state.data.settings.display_config.post_payment_page.customization || DEFAULT_CUSTOMIZATION_CONFIG;
        if (txn_id && state.txn.status) {
            return (
                <>
                    <RenderLogoAndName isRender={isMobile} customization={customization} isPrePayment={false} />
                    <Row className="smart-pay" gutter={24} >
                        <Col className={`col-post-description`}
                            style={['success'].includes(state.txn.data.status) ? { height: "68vh" } : { height: "64vh" }}
                            order={isMobile ? 2 : 1}
                            xl={{ span: 14 }} lg={{ span: 14 }} xs={{ span: 24 }}>
                            <PostPaymentInfoForm />
                        </Col>
                        <Col className="col-post-payment" order={isMobile ? 1 : 2}
                            xl={{ span: 10 }} lg={{ span: 10 }} xs={{ span: 24 }}>
                            <PostPaymentForm />
                        </Col>
                    </Row>
                    <PostPaymentRetryButton isRender={isMobile && !['success'].includes(state.txn.data.status)} />
                    <PostPaymentUserForm isRender={isMobile && !state.feedback.status && !state.txn.is_postpayment_feedback_completed} />
                </>
            )
        }
        return <SmartPayError status={500} title="Transaction Not Found" errorMsg="Either we made a mistake or you are looking for something else" />
    }

    const InitalLayout = () => {
        if (state.error.showError) {
            return <SmartPayError status={state.error.status} title={state.error.errorTitle}
                errorMsg={state.error.errorMsg} showDesc={state.error.showDesc} />
        }
        else if (txn_id) {
            return (
                <Skeleton loading={state.isLoading} paragraph={{ rows: 20 }}>
                    <div className="smart-pay-container">
                        <PostPaymentPage />
                    </div>
                </Skeleton>
            )
        }
        else {
            return (
                <Skeleton loading={state.isLoading} paragraph={{ rows: 20 }}>
                    <div className="smart-pay-container">
                        <PrePaymentPage />
                    </div>
                </Skeleton>
            )
        }
    }

    return (
        <InitalLayout />
    )
}

export default SmartPay;
